export const checkAuth = (event) => ({
    type: 'USER_AUTHENTICADED_CHANGED',
    payload: event
})


// WEBPACK FOOTER //
// ./src/main/App/appActions.js